import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { RequestService } from '../request.service';

export enum PUBLISH_MODES {
  ANONYMOUS = 1,
  POST_LIVE = 2,
  ALLOW_USER_PROFILE = 3
}
// TODO: Move to global settings
export const SETTINGS = {
  MAX_CHAR_COUNT_SUMMARY: 60,
  MIN_CHAR_COUNT_DESCRIPTION: 100,
};
@Component({
  selector: 'mmb-web-app-create-request-full',
  templateUrl: './create-request-full.component.html',
  styleUrls: ['./create-request-full.component.scss']
})
export class CreateRequestFullComponent implements OnInit, OnDestroy {
  requestSettings = SETTINGS;
  createRequestForm: UntypedFormGroup = this.formBuilder.group({
    type: [1, Validators.required],
    category: ['', Validators.required],
    country: ['', Validators.required],
    city: [''],
    summary: ['', [Validators.required, Validators.maxLength(this.requestSettings.MAX_CHAR_COUNT_SUMMARY)]],
    description: ['', [Validators.required, , Validators.minLength(this.requestSettings.MIN_CHAR_COUNT_DESCRIPTION)]],
    startDate: ['', Validators.required],
    endDate: ['', Validators.required],
    tags: [[]],
    tag: [],
    isAnonymously: [] // checbox - to check if it is anonymous post or not
  });
  private _publishMode: number = PUBLISH_MODES.ALLOW_USER_PROFILE;
  private _publishSubscription: Subscription;

  constructor(private formBuilder: UntypedFormBuilder,
              private toastr: ToastrService,
              private requestService: RequestService,
              private router: Router) { }

  ngOnInit() {
    // subscribe to toggle box
    this._subscribeToPublishModeChanges();
  }

  ngOnDestroy() {
    if (this._publishSubscription) {
      this._publishSubscription.unsubscribe();
    }
  }

  /**
   * Submit to create request
   */
  onSubmit() {
    const convertedDate = this._convertTimeStamp();

    const data = {
      body: this.createRequestForm.controls['description'].value,
      request_type: this.createRequestForm.controls['type'].value,
      category: this.createRequestForm.controls['category'].value,
      country: this.createRequestForm.controls['country'].value,
      city: this.createRequestForm.controls['city'].value,
      title: this.createRequestForm.controls['summary'].value,
      start_date: convertedDate.startDateFormated,
      end_date: convertedDate.endDateFormated,
      allow_profile_visible: this._publishMode,
      tags: this.createRequestForm.controls['tags'].value
    };

    if (this.createRequestForm.invalid) {
      this.toastr.error('Please fill all the required fields', 'Error');
      return;
    }

    this.requestService.createRequest(data).subscribe(() => {
      this.toastr.success('Created the request successfully', 'Success');
      this.router.navigate(['/requests']);
    }, (err) => {
      this.toastr.error('Unable to create request', 'Error');
    });
  }

  /**
   * Save the request draft for later
   */
  onSave() {
    this.requestService.saveRequestDraft().subscribe(() => {
      this.toastr.success('Saved the request successfully', 'Success');
      this.router.navigate(['/requests']);
    }, (err) => {
      this.toastr.error('Unable to save request', 'Error');
    });
  }

  /**
   * Cancels create request flow
   */
  onCancel() {
    this.createRequestForm.reset();
    this.router.navigate(['/requests']);
  }

  /**
   * Subscribe to anoymous toggle
   */
  private _subscribeToPublishModeChanges() {
    this._publishSubscription = this.createRequestForm.controls['isAnonymously'].valueChanges.subscribe((newValue: boolean) => {
      this._publishMode = newValue ? PUBLISH_MODES.ANONYMOUS : PUBLISH_MODES.ALLOW_USER_PROFILE;
    });
  }

  /**
   * Converts timestamp to
   */
  private _convertTimeStamp() {
    const date = new Date();
    const seconds = date.getSeconds();
    const minutes = date.getMinutes();
    const hour = date.getHours();

    const startDateFormated = `${this.createRequestForm.controls['startDate'].value}T${hour}:${minutes}:${seconds}Z`;
    const endDateFormated = `${this.createRequestForm.controls['endDate'].value}T${hour}:${minutes}:${seconds}Z`;
    return {
      startDateFormated,
      endDateFormated
    };
  }
}
